import React from "react";
import styled from "styled-components";
import {Header, Title} from "./Headings";
import {subduedTextColour} from "../../../style/styleConsts";
import {SentimentChange, SentimentValue} from "../sentiment/Sentiment";

const Container = styled.div`
    flex-grow: 1;
`;

const SentimentContainer = styled.div`
    display: flex;
    align-items: center;
    height: 36px;
`;

const ChangeContainer = styled.div`
    margin-left: 5px;
    color: ${subduedTextColour};
`;

const NetworkSentiment = ({sentiment}) => {
    return <Container className="t-indicator">
        <Header>Whole TIM Network</Header>
        <Title>Sentiment</Title>
        <SentimentContainer>
            <SentimentValue large={true} sentiment={sentiment}/>
            <ChangeContainer><SentimentChange sentiment={sentiment}/> today</ChangeContainer>
        </SentimentContainer>
    </Container>;
}

export default NetworkSentiment;